import {Locale} from '@hebcal/hdate';
import poData from './de.po.js';
Locale.addLocale('de', poData);
